export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'defaultImageUrl',
    width: 120,
    title: that.$l('table_label_picture') || '图片',
    align: 'center',
    slots: { default: 'defaultImageUrl' },
  },
  {
    field: 'materialNo',
    align: 'left',
    headerAlign: 'left',
    minWidth: 180,
    title: that.$l('table_label_material_no') || '物料编号',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNoInfo' },
  },
  {
    field: 'materialName',
    align: 'left',
    headerAlign: 'left',
    minWidth: 230,
    title: that.$l('table_label_material_name') || '物料名称',
    showHeaderOverflow: 'title',
    slots: { default: 'materialNameInfo' },
  },
  {
    field: 'displayName',
    align: 'left',
    headerAlign: 'left',
    minWidth: 260,
    title: that.$l('table_label_display_name') || '属性描述',
    showHeaderOverflow: 'title',
    slots: { default: 'displayNameInfo' },
  },
  {
    field: 'metadataDesc',
    align: 'left',
    headerAlign: 'left',
    minWidth: 200,
    title: that.$l('table_label_metadata_desc') || '门幅/克重',
    showHeaderOverflow: 'title',
  },
  {
    field: 'usageQty',
    align: 'center',
    headerAlign: 'center',
    minWidth: 100,
    title: that.$l('table_label_usageQty') || '耗料',
    showHeaderOverflow: 'title',
    slots: { default: 'usageQtyInfo' },
  },
  {
    field: 'price',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_price') || '单价',
    showHeaderOverflow: 'title',
    required: 'validRules',
    slots: { default: 'priceInfo' },
  },
  {
    field: 'subTotal',
    align: 'center',
    headerAlign: 'center',
    minWidth: 120,
    title: that.$l('table_label_subTotal') || '成本小计',
    showHeaderOverflow: 'title',
  },
  {
    field: 'scmName',
    align: 'left',
    headerAlign: 'center',
    minWidth: 300,
    title: that.$l('table_hand_nameOfManufacturer') || '厂商名称',
    showHeaderOverflow: 'title',
  },
]
